<div class="mtc-toasts__container">
  @for (toast of toasts; track $index) {
    <ux-toast-message [category]="toast.severity"
                      [message]="toast.message"
                      [lifetime]="toast.timeout ?? 3000"
                      class="mtc-toasts__toast"></ux-toast-message>
  }
</div>
